import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { MarkovDataset } from "server/models"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_MARKOV_MODEL,
    StoreType,

    LoadAllMarkovDatasets,
    DeleteMarkovDataset,

    setMarkovDatasets,
    setMarkovDatasetSelected,
    setMarkovDatasetReloadList,
    addModal,
} from "client/store"
import {
    Collapse,
    Container,
    Loader,
    PageForm,
    FormGroup,
    Label,
    SelectDropdown,
    SelectDropdownItem,
    Button,
    SpinnerIcon,
    Empty,

    PopupMenu,
    PopupMenuItem,

    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
} from "client/components"

import EditDataset from "client/pages/markov/dataset/edit"
import VariableList from "client/pages/markov/variable/list"

const actionButtonStyle: React.CSSProperties = {
    marginLeft: "15px",
    transform: "translateY(18px)",
}

const List = () => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const datasets = useSelector((state: StoreType) => state.markovDataset.datasets)
    const datasetSelected = useSelector((state: StoreType) => state.markovDataset.datasetSelected)
    const reloadList = useSelector((state: StoreType) => state.markovDataset.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)
    const [deleteDataset, setDeleteDataset] = useState<MarkovDataset>(null)

    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const [showPopup, setShowPopup] = useState(false)
    const [popupTarget, setPopupTarget] = useState<HTMLElement>(null)

    const hideMenu = () => {
        setShowPopup(false)
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAllMarkovDatasets(model && model.id).then((res) => {
            const prevSelected = datasetSelected && res.find((row) => row.id === datasetSelected.id)
            dispatch(setMarkovDatasets(res))
            dispatch(setMarkovDatasetSelected(prevSelected || (res.length ? res[0] : null)))
            setLoadState(IDLE)
        })
    }, [model, reloadList])

    const closeConfirm = () => {
        setDeleteDataset(null)
    }

    const onConfirmDelete = () => {
        setDeleteState(PENDING)
        DeleteMarkovDataset(deleteDataset.id, model.id).then(() => {
            dispatch(setMarkovDatasetReloadList(false))
            setTimeout(() => {
                dispatch(setMarkovDatasetReloadList(true))
            }, 0)

            setDeleteDataset(null)
            setDeleteState(IDLE)
        })
    }

    const editModelAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    return (
        <Collapse
            show={show}
            onCollapse={() => setShow(!show)}
            title={lang.datasets}
        >
            <Container>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <PageForm row noPaddingBottom>
                    <FormGroup>
                        <Label>{lang.datasets}</Label>
                        <SelectDropdown title={datasetSelected ? datasetSelected.name : <Empty />}>
                            {
                                datasets.map((dataset) => (
                                    <SelectDropdownItem
                                        key={dataset.id}
                                        onClick={() => dispatch(setMarkovDatasetSelected(dataset))}
                                    >
                                        {dataset.name}
                                    </SelectDropdownItem>
                                ))
                            }
                        </SelectDropdown>
                    </FormGroup>
                    {
                        editModelAccess && (
                            <Button
                                after
                                style={actionButtonStyle}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setShowPopup(true)
                                    setPopupTarget(e.target as HTMLElement)
                                }}
                            >
                                {lang.actions}
                            </Button>
                        )
                    }
                </PageForm>
                <VariableList />

                <PopupMenu
                    show={showPopup}
                    target={popupTarget}
                    placement="bottom-end"
                    showArrow={false}
                >
                    <PopupMenuItem
                        onClick={() => dispatch(addModal({
                            key: "addDataset",
                            content: <EditDataset datasetId={0} />,
                        }))}
                    >
                        {lang.add}
                    </PopupMenuItem>
                    {
                        datasetSelected && (
                            <PopupMenuItem
                                onClick={() => dispatch(addModal({
                                    key: "editDataset",
                                    content: <EditDataset datasetId={datasetSelected.id} />,
                                }))}
                            >
                                {lang.edit}
                            </PopupMenuItem>
                        )
                    }
                    {
                        datasetSelected && (
                            <PopupMenuItem key="copy">
                                TODO: copy
                            </PopupMenuItem>
                        )
                    }
                    {
                        datasetSelected
                        && datasets.length > 1 // there must be at least one Data Set
                        && (
                            <PopupMenuItem onClick={() => setDeleteDataset(datasetSelected)}>
                                {lang.delete}
                            </PopupMenuItem>
                        )
                    }
                </PopupMenu>

                <ConfirmWrapper
                    show={!!deleteDataset}
                    onClose={closeConfirm}
                >
                    <Confirm>
                        <ConfirmTitle>
                            {deleteDataset && deleteDataset.name}
                        </ConfirmTitle>
                        <ConfirmDescription>{lang.confirmDeleteDataset}</ConfirmDescription>

                        <ConfirmBottom>
                            <Button row onClick={closeConfirm}>{lang.cancel}</Button>
                            <Button variant="success" row onClick={onConfirmDelete}>
                                {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                            </Button>
                        </ConfirmBottom>
                    </Confirm>
                </ConfirmWrapper>
            </Container>
        </Collapse>
    )
}
export default List
